// extracted by mini-css-extract-plugin
export default {"About":"About_About__eVqTg","flip-board":"About_flip-board__VBMuj","games-list":"About_games-list__dD4F1","game-box":"About_game-box__RUKnk"};